import Vue from 'vue';
import VueResource from 'vue-resource';
import App from '@/App.vue';
import router from './router';
import VueAnalytics from 'vue-analytics';
import store from './store';
import vuetify from './plugins/vuetify';
import AuthService from '@/services/auth.service.js';
import axios from 'axios';
import config from './config/config.json';

Vue.config.productionTip = false

// Init adal authentication - then create Vue app.
Vue.prototype.$AuthService = new AuthService(config.authentication);
Vue.use(VueResource);

axios.interceptors.request.use(function(config) {
  let authentication = Vue.prototype.$AuthService;

  if (!authentication.isAuthenticated()) {
    console.log("Not authenticated, reload");
    return router.go();
  }

  const token = authentication.getToken();
  if(token) {
      config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, function(err) {
  console.log(err);
  return Promise.reject(err);
});



//authentication.initialize(config.authentication, false).then(() => {  
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app');

  Vue.use(VueAnalytics, {
    id: 'UA-179243431-1',
    router
  });
//});


/*
import Vue from 'vue'
import router from './router'

new Vue({
  router
}).$mount('#app')
*/